export const locale = {
    lang: 'es',
    data: {
      'WIZARD': {
            'TITULO' : 'Expedientes de colaboradores',
            'DESCRIPCION': 'Cargue los expepedientes de sus colaboradores',
            'Carga':'Presione aquí para cargar un archivo',
            'Inicio': 'Inicio',
            'ERROR1':'Formulario no valido',
            'ACC1':'Registro completado',
            'COPY':'Se ha copiado la clave en el porta papeles',
            'DATE':'Citas del doctor',
            'SEARCH':'Buscar',
            'OPC1':'Personas que necesitan atención medica',
            'OPC2':'Personas que sufrieron acontecimiento traumático severo',
            'CARGANDO_FILTROS':'Cargando información, por favor espere...',
            'MEDICOS':{
              'TITULO':'Sección de médicos'
            },
            'ALERT':{
              'BTN1':'Sí',
              'BTN2':'No',
              'LABEL01':'Aún no ha dado de alta a ningún médico',
              'LABEL02':'Aún no hay citas agendadas',
              'LABEL03':'Seguro que desea continuar con esta acción',
            },
            'DatosColaboradores':{
                'Nombre': 'Nombre del colaborador',
                'Correo': 'Correo electrónico',
                'Tel': 'Número telefónico',
                'Area': 'Área',
                'NOFOUND':'Este centro no tiene colaboradores que necesiten atención médica',
                'NOFOUNDDATA':'Aún no cuenta con los resultados de la encuesta'
            },
            'DATOSDOCTORES':{
              'NOMBRE':'Nombre completo',
              'CURP':'CURP',
              'CEDULA':'Cédula profesional',
              'ESPECIALIDAD':'Especialidad',
              'CT':'Centro de trabajo',
              'TELEFONO':'Teléfono',
              'DOMICILIO':'Domicilio',  
              'EMAIL':'Correo electrónico', 
              'ERROR':{
                'ERR01':'Campo necesario',
              },
              'ACCIONES':{
                'LABEL01':'Agregar médico',
                'LABEL02':'Nuevos médicos',
                'LABEL03':'Registrar',
                'LABEL04':'Cerrar'
              },
              'PANEL':{
                'LABEL01':'Nombre',
                'LABEL02':'Correo',
                'LABEL03':'Cedula',
                'LABEL04':'Especialidad',
                'LABEL05':'Centro de trabajo',
                'LABEL06':'Domicilio',
                'LABEL07':'Telefono',
                'LABEL08':'Clave',
                'LABEL09':'Borrar',
                'LABEL10':'Acciones',
                'LABEL11':'Copiar clave'
              }  
            }
            
        }
      }
};
